import { render, staticRenderFns } from "./ShopifySavebar.vue?vue&type=template&id=5daf16cf&scoped=true"
import script from "./ShopifySavebar.vue?vue&type=script&lang=js"
export * from "./ShopifySavebar.vue?vue&type=script&lang=js"
import style0 from "./ShopifySavebar.vue?vue&type=style&index=0&id=5daf16cf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5daf16cf",
  null
  
)

export default component.exports